import React, { useEffect, useRef, useState } from "react";

const HeaderContactDropdown = ({
  isMobilescreen,
  openContactDropdown,
  setOpenContactDropdown,
}) => {
  const dropdownRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenContactDropdown(false);
      }
    };

    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  useEffect(() => {
    if (openContactDropdown) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [openContactDropdown]);

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setOpenContactDropdown((prev) => !prev);
  };

  const closeDropdown = (e) => {
    e.stopPropagation();
    setOpenContactDropdown(false);
  };

  return (
    <div
      className={`header_contact_dropdown ${
        openContactDropdown ? "active" : ""
      }`}
      onClick={toggleDropdown}
      ref={dropdownRef}
    >
      <div className="relative">
        <ul className="header_contact_list inner-flex">
          <li>
            <a href="tel:918000585555">
              <div className="header_contact_content flex-row alc">
                <span className="material-symbols-outlined">call</span>
                <div className="header_contact_dropdown_text">
                  <p>Call</p>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a
              href="https://wa.me/918000585555"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="header_contact_content flex-row alc">
                <div className="header_contact_dropdown_img common-icon">
                  <img src="/images/icon/whatsapp.svg" alt="WhatsApp" />
                </div>
                <div className="header_contact_dropdown_text">
                  <p>WhatsApp</p>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="mailto:info@swatiprocon.com">
              <div className="header_contact_content flex-row alc">
                <span className="material-symbols-outlined">mail</span>
                <div className="header_contact_dropdown_text">
                  <p>Email</p>
                </div>
              </div>
            </a>
          </li>
        </ul>

        {/* {isMobilescreen && ( */}
        <div className="close_contact" onClick={closeDropdown}>
          <img
            src="/images/icon/close.svg"
            style={{ filter: "invert(1)" }}
            alt="Close"
          />
        </div>
        {/* )} */}
      </div>
    </div>
  );
};

export default HeaderContactDropdown;
